var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var LinkingManager = require('./wrappers/LinkingManager');
var NetworkManager = require('./NetworkManager');

var {
  View,
  StyleSheet,
} = ReactNative;

var Facebook = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {

    }
  },

  getInitialState : function()
  {
    return {

    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  render: function()
  {
    return (<View />)
  }
});

Facebook.getCards = function(featureData, appActions, data)
{
  return []; // disabling facebook

  var didSelect = function()
  {
    Facebook.customNavigation(featureData, appActions);
  };
  var appManager = appActions._appManager;
  var iconName = featureData.data.icon.replace("fa-", "")
  var cards = [];
  if( typeof data.Facebook !== 'undefined' )
  {
    data.Facebook = data.Facebook.sort(function(a,b)
    {
      return b.created_time - a.created_time;
    });

    var MAX_FACEBOOK_POSTS = 1;
    for( var i = 0; i < data.Facebook.length && i < MAX_FACEBOOK_POSTS; i++ )
    {
      var fb = data.Facebook[i];
      var message = fb.message;
      var date = new Date(fb.created_time*1000)
      var dateText = appManager.timeSince(date);
      var sortOrder = (new Date()).getTime() - (fb.created_time*1000);
      var attachments = typeof fb.attachments !== 'undefined' ? fb.attachments : [];

      cards.push({
        key : "fb-"+fb.id,
        didSelect : didSelect,
        smallTitle : dateText,
        body1 : message,
        picture : fb.picture,
        icon : iconName,
        cardType : 0,
        sortOrder : sortOrder
      })
    }
  }
  return cards;
}
Facebook.customNavigation = function(featureData, appActions)
{
  // facebook linking not working on iOS, so just use the URL
  var facebookURL = "fb://page/"+featureData.data.facebook_user_id;
  LinkingManager.canOpenURL(facebookURL, function(can)
  {
    if( can )
    {
      LinkingManager.openURL(facebookURL)
    }
    else
    {
      var url = "https://www.facebook.com/"+featureData.data.facebook_user_id;
      var appManager = appActions._appManager;
      var barTintColor = appManager.getColorForKey("HeaderColor");
      var tintColor = appManager.getColorForKey("HeaderIconColor");

      LinkingManager.openURL(url, tintColor, barTintColor);
    }
  })
}
// Facebook.customDependencyKeys = ["Facebook"];
// Facebook.customDataDependency = function(appManager, completion)
// {
//   var featureData = appManager.getFeatureForName("Facebook");
//   NetworkManager.getFacebookInfo(appManager, featureData.data.facebook_user_id, function(data)
//   {
//     appManager.setData({Facebook:data}, function()
//     {
//       completion({Facebook:data})
//     })
//   }, function(a)
//   {
//     completion({})
//   }, function()
//   {
//     completion({})
//   })
// }

Facebook.dataDependencies = [];

module.exports = Facebook;
